import { BrowserRouter, Switch, Route } from "react-router-dom";
import Layout from "./Components/Layout/Layout";
import HomePage from "./pages/Homepage/Homepage";
import theme from "./themes/index";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import './themes/font.css'
import Login from "./pages/Login/Login";
import register from "./pages/Register/Register"
import Register from "./pages/Register/Register";

function App() {
  const mytheme = createMuiTheme({
    ...theme,
  });
  return (
    <BrowserRouter>
      <div className="App">
          <Switch>
          <Route exact  path="/buyer/login"  component={Login} />
          <Route exact  path="/buyer/register"  component={Register} />
            <PrivateRoute path="/">
              <Layout />
            </PrivateRoute>
          </Switch>
      </div>
    </BrowserRouter>
  );

  function PrivateRoute({ children, ...rest }) {
		return (
			<Route
				{...rest}
				render={() => children}
			/>
		);
	}
}

export default App;
